import { computed } from 'vue'

export const appliedDiscountsConfig = {
  PROMOCODE: {
    label: 'PROMOCODE',
    columns: [
      { label: 'CLIENTE', field: 'clientId' },
      { label: 'PROMOCODE', field: 'promoCode' },
      { label: 'DESC. SPREAD', field: 'spreadDiscountPercentage' },
      { label: 'DESC. TARIFA', field: 'clientTaxDiscountPercentage' }
    ]
  },
  INDICATE_AND_WIN: {
    label: 'INDIQUE E GANHE',
    columns: [
      { label: 'CLIENTE', field: 'clientId' },
      { label: 'DESC. SPREAD', field: 'spreadDiscountPercentage' },
      { label: 'DESC. TARIFA', field: 'clientTaxDiscountPercentage' },
      { label: 'QUANT. UTILIZADA', field: 'accumulation' }
    ]
  },
  INDICATE_AND_WIN_FIRST_TIME_OPERATION: {
    label: 'INDIQUE E GANHE (1ª OPERAÇÃO)',
    columns: [
      { label: 'CLIENTE', field: 'clientId' },
      { label: 'DESC. SPREAD', field: 'spreadDiscountPercentage' },
      { label: 'DESC. TARIFA', field: 'clientTaxDiscountPercentage' }
    ]
  },
  PROMOCODE_GIFT_CARD: {
    label: 'GIFT CARD',
    columns: [
      { label: 'CLIENTE', field: 'clientId' },
      { label: 'PROMOCODE', field: 'promoCode' }
    ]
  }
}

export function useAppliedDiscounts(appliedDiscountsRef) {
  const appliedDiscountsConfigsFiltered = computed(() => {
    return Object.keys(appliedDiscountsConfig)
      .filter((type) => appliedDiscountsRef.value.some((d) => d.type === type))
      .reduce((acc, type) => {
        acc[type] = appliedDiscountsConfig[type]
        return acc
      }, {})
  })

  const getAppliedDiscountsByType = (type) =>
    appliedDiscountsRef.value.filter((d) => d.type === type)

  const getAppliedDiscountValue = (discount, field) => {
    if (field === 'spreadDiscountPercentage' && discount.spreadConstantPercentageEnabled) {
      return `FIXO: ${discount.spreadConstantPercentage}%`
    }

    if (field === 'clientTaxDiscountPercentage' && discount.clientTaxConstantValueEnabled) {
      return `FIXO: USD ${discount.clientTaxConstantValue.toFixed(2)}`
    }

    if (['spreadDiscountPercentage', 'clientTaxDiscountPercentage'].includes(field)) {
      return discount[field] != null ? `${discount[field]}%` : 'N/A'
    }

    return discount[field] ?? '—'
  }

  return {
    appliedDiscountsConfigsFiltered,
    getAppliedDiscountsByType,
    getAppliedDiscountValue
  }
}
